@if (vehicles.length > 0) {
@if (hasMultipleTypes) {
<!-- Mostrar agrupado por tipo cuando hay múltiples tipos -->
@for (group of groupedVehicles; track group.vehicleType; let isLast = $last) {
<div class="vehicle-type-group">
  <div class="vehicle-type-header">
    <span class="vehicle-type-icon" [innerHTML]="getVehicleTypeIcon(group.vehicleType)" data-ap-external></span>
    <h3 class="vehicle-type-title">{{ group.vehicleType }}</h3>
  </div>
  <div class="vehicle-list">
    @for (vehicle of group.vehicles; track vehicle.IdVehicle) {
    <ng-container *ngTemplateOutlet="vehicleCard; context: { vehicle }"></ng-container>
    }
  </div>
  @if (!isLast) {
  <hr class="vehicle-type-divider" />
  }
</div>
}
} @else {
<!-- Mostrar directamente sin agrupar cuando hay solo un tipo -->
<div class="vehicle-list">
  @for (vehicle of vehicles; track vehicle.IdVehicle) {
  <ng-container *ngTemplateOutlet="vehicleCard; context: { vehicle }"></ng-container>
  }
</div>
}
} @else {
<div class="no-vehicles">
  <div class="alert alert-primary" role="alert">
    No hay vehículos disponibles
  </div>
</div>
}

<ng-template #vehicleCard let-vehicle="vehicle">
  <div class="vehicle-card-container">
    @if (vehicleHtmlContent[vehicle.IdVehicle]) {
    <div class="vehicle-card" [innerHTML]="vehicleHtmlContent[vehicle.IdVehicle]" data-ap-external></div>
    } @else if (vehicle.HtmlInfoFile) {
    <div class="vehicle-card">Cargando información...</div>
    }
    <div class="vehicle-actions">
      <button class="btn btn-primary btn-lg" (click)="onReserve(vehicle)">
        Quiero probarlo
      </button>
    </div>
  </div>
</ng-template>